import { makeStyles } from 'tss-react/mui';
import { teceoFontFamily } from '../../../../../../../../../../Theme';
import {
  ROOM_ITEM_BACKGROUND_COLOR_WITHOUT_NOTIFICATION,
  ROOM_ITEM_BACKGROUND_COLOR_WITH_NOTIFICATION,
} from '../../../../utils/styles.const';

interface UseChatRoomItemStylesProps {
  hasNotification: boolean;
}

export const useChatRoomItemStyles = makeStyles<UseChatRoomItemStylesProps>()(
  (theme, { hasNotification }) => ({
    button: {
      width: '100%',
      borderRadius: '0px',
      padding: '12px 20px',
      backgroundColor: hasNotification
        ? ROOM_ITEM_BACKGROUND_COLOR_WITH_NOTIFICATION
        : ROOM_ITEM_BACKGROUND_COLOR_WITHOUT_NOTIFICATION,

      [theme.breakpoints.down('sm')]: {
        height: '64px',
      },

      '& *': {
        fontFamily: teceoFontFamily,
      },
    },
    title: {
      maxWidth: '192px',
      textAlign: 'start',
      fontWeight: hasNotification ? 700 : 500,
    },
    badge: {
      height: '16px',
      minWidth: '16px',
      padding: '0px 4px',
    },
  }),
);
